import { useEffect, useState } from 'react';

// Lehký globální toast store (bez závislostí). Volatelný odkudkoliv: toast.success('…').
export type ToastKind = 'success' | 'error' | 'info';
export interface ToastAction { label: string; onClick: () => void }
export interface Toast { id: number; kind: ToastKind; message: string; action?: ToastAction }

let items: Toast[] = [];
let nextId = 0;
const listeners = new Set<(t: Toast[]) => void>();
const emit = () => listeners.forEach((l) => l(items));

export function dismissToast(id: number): void {
  items = items.filter((t) => t.id !== id);
  emit();
}

function show(message: string, kind: ToastKind, action?: ToastAction): number {
  const id = ++nextId;
  items = [...items, { id, kind, message, action }];
  emit();
  // Toasty s akcí (např. Vrátit) žijí dél, ať je stihneš kliknout.
  window.setTimeout(() => dismissToast(id), action ? 7000 : 3500);
  return id;
}

export const toast = {
  success: (m: string, a?: ToastAction) => show(m, 'success', a),
  error: (m: string, a?: ToastAction) => show(m, 'error', a),
  info: (m: string, a?: ToastAction) => show(m, 'info', a),
};

const KIND_STYLE: Record<ToastKind, string> = {
  success: 'border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950 text-emerald-900 dark:text-emerald-200',
  error: 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-950 text-red-900 dark:text-red-200',
  info: 'border-zinc-300 dark:border-zinc-700 bg-white dark:bg-zinc-900 text-zinc-800 dark:text-zinc-100',
};
const KIND_ICON: Record<ToastKind, string> = { success: '✓', error: '✕', info: 'ℹ' };

export function Toaster() {
  const [list, setList] = useState<Toast[]>(items);
  useEffect(() => {
    listeners.add(setList);
    return () => { listeners.delete(setList); };
  }, []);

  if (list.length === 0) return null;
  return (
    <div className="fixed bottom-24 right-4 z-[100] flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2 md:bottom-4">
      {list.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`flex items-start gap-2 rounded-lg border px-3 py-2.5 text-sm shadow-lg ${KIND_STYLE[t.kind]} animate-[fadeIn_120ms_ease-out]`}
        >
          <span className="mt-0.5 shrink-0 font-bold">{KIND_ICON[t.kind]}</span>
          <span className="min-w-0 flex-1">{t.message}</span>
          {t.action && (
            <button
              onClick={() => { t.action!.onClick(); dismissToast(t.id); }}
              className="shrink-0 font-semibold underline underline-offset-2 hover:opacity-80"
            >
              {t.action.label}
            </button>
          )}
          <button onClick={() => dismissToast(t.id)} className="shrink-0 text-base leading-none opacity-50 hover:opacity-100" aria-label="Zavřít">×</button>
        </div>
      ))}
    </div>
  );
}
